const shareSetting = () => import('@/view/mall/share-setting');
const banner = () => import('@/view/mall/banner'); // 轮播图
const article = () => import('@/view/mall/article'); //
// const powerManage = () => import('@/view/mall/power-Manage');
// const menuMaintain = () => import('@/view/mall/menu-Maintain');
// const powerEdit = () => import('@/view/mall/power-Edit');
const powerMemberList = () => import('@/view/mall/powerMember-List');
const accountManage = () => import('@/view/mall/account-manage');
const menuManage = () => import('@/view/mall/menu-manage');
const currencySetting = () => import('@/view/mall/currency-setting');
const userSetting = () => import('@/view/mall/user-setting');
const noDeliver = () => import('@/view/mall/no-deliver');
const companyDynamics = () => import('@/view/mall/company-dynamics');
const addDynamics = () => import('@/view/mall/add-dynamics');
const systemManage = () => import('@/view/mall/system-manage');
const freight = () => import('@/view/mall/freight');
const dictionary = () => import('@/view/mall/dictionary');
const dictionaryItem = () => import('@/view/mall/dictionary-item');
const agreement1 = () => import('@/view/mall/agreement1');
const agreement2 = () => import('@/view/mall/agreement2');
const agreementList = () => import('@/view/mall/agreement-list');
const agreementInfo = () => import('@/view/mall/agreement-info');

export default [{
        path: '/share-setting',
        name: 'shareSetting',
        component: shareSetting
    }, {
        path: '/banner',
        name: 'banner',
        component: banner
    }, {
        path: '/article',
        name: 'article',
        component: article
    },
    {
        path: '/powerMemberList',
        name: 'powerMemberList',
        component: powerMemberList
    },
    // {
    //     path: '/powerEdit',
    //     name: 'powerEdit',
    //     component: powerEdit
    // },
    // {
    //     path: '/power-manage',
    //     name: 'power-manage',
    //     component: powerManage
    // },
    {
        path: '/account-manage',
        name: 'account-manage',
        component: accountManage
    },
    {
        path: '/menu-manage',
        name: 'menu-manage',
        component: menuManage
    },
    {
        path: '/currency-setting',
        name: 'currencySetting',
        component: currencySetting
    },
    {
        path: '/no-deliver',
        name: 'noDeliver',
        component: noDeliver
    }, {
        path: '/user-setting',
        name: 'userSetting',
        component: userSetting
    }, {
        path: '/company-dynamics',
        name: 'companyDynamics',
        component: companyDynamics
    },{
        path: '/add-dynamics',
        name: 'addDynamics',
        component: addDynamics
    }, {
        path: '/system-manage',
        name: 'systemManage',
        component: systemManage
    }, {
        path: '/freight',
        name: 'freight',
        component: freight
    }, {
        path: '/dictionary',
        name: 'dictionary',
        component: dictionary
    }, {
        path: '/dictionary-item',
        name: 'dictionaryItem',
        component: dictionaryItem
    }, {
        path: '/agreement1',
        name: 'agreement1',
        component: agreement1
    }, {
        path: '/agreement2',
        name: 'agreement2',
        component: agreement2
    }, {
        path: '/agreement-list',
        name: 'agreementList',
        component: agreementList
    }, {
        path: '/agreement-info',
        name: 'agreementInfo',
        component: agreementInfo
    }
];
